export default "__VITE_ASSET__C9nVVfcY__"